import { render } from "./AfterSalesModal.vue?vue&type=template&id=d94be34c&scoped=true"
import script from "./AfterSalesModal.vue?vue&type=script&lang=js"
export * from "./AfterSalesModal.vue?vue&type=script&lang=js"

import "./AfterSalesModal.vue?vue&type=style&index=0&id=d94be34c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94be34c"]])

export default __exports__